<template>
    <div id="messenger-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: 'Messenger Channel Detail' }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>
        <div class="wrapper" v-if="channel">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/messenger')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <MessengerIcon />
                    </div>
                    <div class="name">{{ $t('messenger.channels') }} : {{ channel.name }}</div>
                </div>
                <div class="right">
                    <a-button type="danger" @click="deleteModal = true"
                        >{{ $t("whatsappChannel.deleteChannel") }}
                    </a-button>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content">
                    <div v-if="currentTab === MessengerMenuTypes.CHANNEL.id">
                        <UpdateDetail v-model="channel" />
                    </div>
                    <div v-if="currentTab === MessengerMenuTypes.VISIBILITY.id">
                        <Visibility v-model="channel" />
                    </div>
                    <div v-if="currentTab === MessengerMenuTypes.COMMENT_SETTINGS.id">
                        <MessengerCommentManagement :value="channel" />
                    </div>
                    <div v-if="currentTab === MessengerMenuTypes.AD_OPTIMIZATION.id">
                        <AdOptimization v-model="channel" />
                    </div>
                </div>
            </div>
        </div>

        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="$t('messenger.channel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("messenger.deleteDesc") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWMessengerChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import SettingsMultiWhatsapp from "../../../WhatsappV1/SettingsMultiWhatsapp.vue";
import IconButton from "../../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import ChannelMenu from "./ChannelMenu.vue";
import Visibility from "./Visibility.vue";
import log2 from "../../../../../utils/log2";
import MessengerMenuTypes from "./MessengerMenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb.vue";
import MessengerIcon from "../../../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import MessengerCommentManagement from "./MessengerCommentManagement.vue";
import AdOptimization from "./AdOptimization.vue";

const log = log2("MessengerChannelDetail.vue");
export default Vue.extend({
    name: "MessengerChannelDetail",
    components: {
        MessengerIcon,
        UpdateDetail,
        Visibility,
        ChannelMenu,
        IconButton,
        SettingsMultiWhatsapp,
        AppBreadCrumb,
        MessengerCommentManagement,
        AdOptimization,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(MessengerMenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            MessengerMenuTypes,
            visible: this.$route.query.action == "start-chat",
            confirmLoading: false,
            whatsappNumber: "",
            showAlertMessage: false,
            dialCode: "+90",
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            channels: (state) => state.channel.channels.filter((x) => x.type === "messenger"),
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.forward.story = null;
            } else {
                if (this.stories[0]) {
                    this.form.forward.story = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        deleteWMessengerChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/messenger");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.originalChannel = _.cloneDeep(this.channel);
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.whatsappNumber = "";
            this.showAlertMessage = false;
        },
        onSelect(value) {
            log("onSelect", value);
            this.dialCode = value.dialCode;
        },
    },
    mounted() {
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(MessengerMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/messenger/${this.channel._id}/detail/${selected.path}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#messenger-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
